module.exports = __webpack_public_path__ + "static/isg-banner-old-748434281d13377472b0426b61531229.png";